import { Link } from "react-router-dom";
import { navLinks, siteMeta } from "@/mocks/site";
import { categories } from "@/mocks/categories";
import { specials } from "@/mocks/specials";

export default function SiteFooter() {
  return (
    <footer className="border-t border-background-200 bg-primary-900 text-background-100">
      <div className="container-page py-12 md:py-16">
        <div className="grid gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-movie-2-line" />
              </span>
              <span className="font-heading text-lg font-semibold text-background-50">{siteMeta.brand}</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-primary-200">
              {siteMeta.slogan}。以杂志编辑的视角整理日本伦理题材影视作品，提供剧集资料、主题专题与观看指引。
            </p>
            <p className="mt-6 font-label text-[10px] tracking-[0.24em] text-primary-300">{siteMeta.tagline}</p>
          </div>

          <div className="md:col-span-2">
            <h3 className="rule-label text-primary-300">导航</h3>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-primary-100 transition-colors hover:text-accent-300">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h3 className="rule-label text-primary-300">分类</h3>
            <ul className="mt-4 space-y-2.5">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.key}>
                  <Link
                    to={`/category/${cat.key}`}
                    className="text-sm text-primary-100 transition-colors hover:text-accent-300"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h3 className="rule-label text-primary-300">专题</h3>
            <ul className="mt-4 space-y-2.5">
              {specials.slice(0, 3).map((item) => (
                <li key={item.id}>
                  <Link
                    to={`/special/${item.id}`}
                    className="text-sm leading-relaxed text-primary-100 transition-colors hover:text-accent-300"
                  >
                    {item.title}
                  </Link>
                </li>
              ))}
            </ul>
            <p className="mt-5 text-xs text-primary-300">联系邮箱：{siteMeta.email}</p>
          </div>
        </div>

        <div className="mt-12 border-t border-primary-800 pt-6">
          <p className="text-[11px] leading-relaxed text-primary-300">{siteMeta.disclaimer}</p>
          <div className="mt-4 flex flex-col gap-2 text-[11px] text-primary-300 sm:flex-row sm:items-center sm:justify-between">
            <span>© 2026 {siteMeta.brand} · 内容演示站点</span>
            <span className="font-label tracking-[0.16em]">EDITORIAL ARCHIVE / DEMO BUILD</span>
          </div>
        </div>
      </div>
    </footer>
  );
}